export default {
  title: 'Get your plan with a SUPER Discount!',
  textFirst: 'We\'re sure that by following this Kegel plan you can improve {goal}. This is confirmed by a huge number of positive reviews.',
  textSecond: 'We want you to reach your goal. That\'s why <span class="font-600">we\'re giving you the super discount</span> so you can start improving your men\'s health at the best price.',
  button: 'Got it',
}
